<template>
  <section class="my-20 border-t border-slate-200">
    <Container>
      <SectionHeader>Video Slideshow</SectionHeader>
      <div>
        <HMTVideoSlideshow />
      </div>
    </Container>
  </section>
</template>

<script>
  import HMTVideoSlideshow from '@/shared/components/VideoSlideshow';
  import SectionHeader from '../../components/SectionHeader';
  import Container from '../../components/Container';
  
  export default {
    name: 'VideoSlideshow',
    components: {
      HMTVideoSlideshow,
      SectionHeader,
      Container
    }
  };
</script>
